var version = '6.1.9';

module.exports = version;
